export default {"src":"/_next/static/media/afs_01.e8b15111.svg","height":106,"width":435,"blurWidth":0,"blurHeight":0};